module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page && _vm.product) ? _c('div', {
    staticClass: "campaign-template animate fadeIn"
  }, [_vm._m(0), _vm._v(" "), (!(_vm.page.data.total_product_price > 0)) ? _c('div', {
    staticClass: "container pd-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10 col-lg-push-2 col-lg-8"
  }, [_c('progress-step', {
    attrs: {
      "steps": ['1 สร้างเพจ', '2 เข้าสู่ระบบ', '3 บริจาค'],
      "active": 3
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "view-page-card-content"
  }, [_c('page-card', {
    ref: "card",
    attrs: {
      "type": _vm.form.type,
      "name": _vm.form.name,
      "date": _vm.date,
      "custom-title": _vm.form.custom_type,
      "top-image": _vm.form.top_image,
      "bottom-image": _vm.form.bottom_image,
      "avatar-image": _vm.form.avatar_image,
      "editing": _vm.editing,
      "page": _vm.page
    },
    on: {
      "edit": _vm.edit,
      "cancel": _vm.cancelEdit
    }
  })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "block-border radius block shadow"
  }, [_c('page-form', {
    attrs: {
      "show-ecard-form": false,
      "submit-button-text": "บันทึก"
    },
    on: {
      "submit": _vm.update
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "block-border radius block shadow"
  }, [(_vm.page.data.message) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.page.data.message) + "\n            "), _c('hr', {
    staticClass: "bd"
  })]) : _vm._e(), _vm._v(" "), (_vm.page) ? _c('donor-list', {
    attrs: {
      "page": _vm.page
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "block-border radius block shadow"
  }, [_c('div', {
    staticClass: "donate-amount"
  }, [_c('div', {
    staticClass: "-label"
  }, [_vm._v("จำนวนเงินบริจาคของคุณ")]), _vm._v(" "), _c('div', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.page.data.total_product_price)) + " บาท")])]), _vm._v(" "), _c('funding-goal', {
    ref: "fundingGoal",
    attrs: {
      "target": _vm.donationTarget,
      "amount": _vm.donationAmount,
      "end-date": _vm.page.data.end_date,
      "percent": _vm.donationProgress
    }
  }), _vm._v(" "), (_vm.page.status === _vm.$const.PAGE_STATUSES.PUBLISHED && _vm.page.data.total_product_price > 0) ? _c('div', [_c('hr', {
    staticStyle: {
      "margin": "20px -20px 0"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center mt-15"
  }, [_vm._v("แชร์เพจนี้")]), _vm._v(" "), _c('div', {
    staticClass: "share text-center",
    staticStyle: {
      "margin": "0 -10px"
    }
  }, [_c('vue-goodshare-facebook', {
    attrs: {
      "page_url": _vm.url + '?v=' + _vm.page.changed,
      "title_social": "Facebook",
      "has_icon": ""
    }
  }), _vm._v(" "), _c('share-line-button', {
    attrs: {
      "page_url": _vm.url + '?v=' + _vm.page.changed,
      "title_social": "Line",
      "has_icon": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-email button-social"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.shareEmailPopup.open.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-envelope"
  }), _vm._v(" ส่ง e-card")])])], 1), _vm._v(" "), _c('share-email-popup', {
    ref: "shareEmailPopup",
    attrs: {
      "page": _vm.page
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.canDonate && !_vm.editing) ? _c('div', {
    staticClass: "block-border radius block shadow"
  }, [(_vm.product) ? _c('donate-choice', {
    ref: "donateChoice",
    attrs: {
      "choices": [200, 500, 2500, 5000],
      "custom": true,
      "defaults": 500,
      "minimum": 20,
      "show-donate-type": false,
      "product": _vm.product
    },
    on: {
      "change": _vm.amountChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('label', {
    attrs: {
      "for": "donor-message"
    }
  }, [_vm._v("ข้อความอวยพร")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.message),
      expression: "attributes.info.message"
    }],
    staticClass: "form__text",
    attrs: {
      "id": "donor-message"
    },
    domProps: {
      "value": (_vm.attributes.info.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributes.info, "message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('label', {
    attrs: {
      "for": "donor-name"
    }
  }, [_vm._v("ชื่อผู้บริจาค")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.name),
      expression: "attributes.info.name"
    }],
    staticClass: "form__text",
    attrs: {
      "type": "text",
      "id": "donor-name",
      "placeholder": "เว้นว่างไว้หากไม่ประสงค์ออกนาม"
    },
    domProps: {
      "value": (_vm.attributes.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributes.info, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.product) ? _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "buy-now-text": "บริจาค",
      "stockAvailable": false,
      "attributes": _vm.attributes,
      "product": _vm.product,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "donate__wrapper"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--default ma-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "campaign-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("บริจาคในโอกาสพิเศษของคุณหรือเพื่อนของคุณ")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("ให้โอกาสทางการศึกษากับน้องๆ ที่ด้อยโอกาส")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fb53b56","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/special-events/view.vue
// module id = 1153
// module chunks = 0